"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
function makeRequest(method, path, options) {
    if (options === void 0) { options = {}; }
    var token = options.token, params = options.params, data = options.data, contentType = options.contentType, upload = options.upload, requestOptions = __rest(options, ["token", "params", "data", "contentType", "upload"]);
    var headers = {};
    headers.Accept = 'application/json';
    headers['Accept-Language'] = navigator.language.toLowerCase();
    if (contentType !== false) {
        headers['Content-Type'] = contentType || 'application/json';
    }
    if (token) {
        if (typeof token === 'string') {
            headers.Authorization = "Bearer " + token;
        }
        else {
            headers.Authorization = token.type + " " + token.value;
        }
    }
    var url = new URL(path, process.env.REACT_APP_API_HOST);
    var controller = axios_1.default.CancelToken.source();
    var promise = axios_1.default(__assign({ url: url.toJSON(), method: method,
        headers: headers,
        params: params,
        data: data, cancelToken: controller.token }, requestOptions))
        .then(function (res) { return res.data || {}; })
        .catch(function (err) {
        var cancelled = axios_1.default.isCancel(err);
        var error = null;
        if (err.response && err.response.data && (err.response.data.message || err.response.data.error)) {
            error = err.response.data.message
                ? { statusCode: null, cancelled: cancelled, message: err.response.data.message }
                : err.response.data.error;
        }
        else if (err.message) {
            // {message: "Cancelled by user"}
            error = { statusCode: null, cancelled: cancelled, message: err.message };
        }
        else {
            error = { statusCode: null, cancelled: cancelled, message: 'Network error' };
        }
        return Promise.reject(error);
    });
    if (upload) {
        return { promise: promise, cancel: function () { return controller.cancel('Cancelled by user'); } };
    }
    promise.cancel = function () { return controller.cancel('Cancelled by user'); };
    return promise;
}
exports.default = {
    get: function (path, options) {
        return makeRequest('GET', path, options);
    },
    post: function (path, data, options) {
        return makeRequest('POST', path, __assign(__assign({}, options), { data: data }));
    },
    put: function (path, data, options) {
        return makeRequest('PUT', path, __assign(__assign({}, options), { data: data }));
    },
    patch: function (path, data, options) {
        return makeRequest('PATCH', path, __assign(__assign({}, options), { data: data }));
    },
    delete: function (path, options) {
        return makeRequest('DELETE', path, options);
    },
    upload: function (path, data, options) {
        var form = new FormData();
        Object.keys(data).forEach(function (key) {
            form.append(key, data[key]);
        });
        return makeRequest('POST', path, __assign(__assign({}, options), { upload: true, data: form }));
    },
    mock: function (data, options) {
        if (options === void 0) { options = {}; }
        return new Promise(function (resolve, reject) {
            return setTimeout(function () { return (options.success === false ? reject(data) : resolve(data)); }, options.delay || 1000);
        });
    },
};
